<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Daftar Antrian Mobile</h5>
            </template>
            <div class="form-content-wrapper mb-4">  
                <div class="d-flex form-content-wrapper mb-4">
                    <b-form-group class="mr-2 mb-0">
                        <b-form-input ref="inputNoRef"
                            v-model="input.noRef" :disabled="isBusy" v-on:keyup.enter="getItems()" name="filterTable"
                            id="filterInput"
                            placeholder="No. Referensi"
                        ></b-form-input>
                    </b-form-group>
                    <b-button variant="pgiBtn" name="searchTableBtn" @click="getItems()"> 
                        <b-spinner small class="loading-spinner" v-if="isBusy"></b-spinner>
                        <i class="fa fa-search" v-else></i>
                    </b-button>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="items" 
                        :fields="fields" 
                        responsive class="mb-3"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Mengambil data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data antrian.
                        </template>
                        <template v-slot:cell(barang)="row">
                            <p class="mb-0">{{ row.item.jenis }}</p>
                            <p class="mb-0 smallText text-muted">{{ row.item.merk }} - {{ row.item.tipe }}</p>
                            <p class="mb-0 smallText text-muted">{{ row.item.warna }} {{ row.item.tahun != null ? `- Tahun ${row.item.tahun}` : "" }}</p>
                        </template>
                        <template v-slot:cell(createdAt)="row">
                            {{ $helper.changeDateFormat(row.item.createdAt) }}
                            <div class="small">{{ $helper.changeDateFormatGetHour(row.item.createdAt) }}</div>
                        </template>
                    </b-table>

                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="show" @change="onLimitChange" :options="options">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewText }}</span>
                        </b-input-group>
                        <b-pagination class="mb-0"
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>

export default {
    name: 'antrian-mobile-pusat',
    data() {
        return {

            isBusy: false,
            isSubmitting: false,
            show: 1,

            input: {
                noRef: "",
            },

            options: [
                { value: 1, text: '10'},
                { value: 2, text: '20'},
                { value: 3, text: '30'},
                { value: 4, text: '40'},
                { value: 5, text: '50'},
            ],

            fields: [
                { key: "noReferensi", label: "No. Referensi" },
                { key: "nasabah", label: "Nasabah" },
                { key: "barang", label: "Barang" },
                { key: "createdAt", label: "Dibuat pada"},
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            totalViewText: ""

        }
    }, 

    methods: {

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)

            if(!this.$helper.isNullOrEmpty(this.input.noRef)) {
                param += "&filterNoRef=" + this.input.noRef
            }

            return this.$axios.get("gadai-mobile/antrian/pusat/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

                let pg = this.currentPage - 1

                let prev = pg * this.show + 1
                let limit = pg * this.show + this.show
                if (limit > this.totalRows) limit = this.totalRows

                this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

    },

    created() {
        this.getItems()
    }

}
</script>
